<div class="zn-step-content-sections">
    <div class="zn-step-content-section zn-step-content-section--selected zn-full-height">
        <div class="zn-step-content-section-header">
            <div class="zn-step-content-section-header-inner-container">
                <div class="zn-step-content-section-titles">
                    <h5>{{ (localizationKeyPrefix + '.SelectedStandsTable.Title') | abpLocalization }}</h5>
                    <p>{{ (localizationKeyPrefix + '.Description') | abpLocalization }}</p>
                </div>
            </div>
            <hr class="zn-separator">
        </div>

        <div class="zn-step-content-section-body">
            <div class="zn-table zn-table--inventory-validation">
                <div class="zn-table-scroll">
                    <table class="zn-table-element">
                        <thead>
                            <tr>
                                <th colspan="9" scope="colgroup"></th>
                                <th colspan="6" scope="colgroup" class="zn-table-group-header">{{ (localizationKeyPrefix + '.PreviousSelections') | abpLocalization }}</th>
                            </tr>
                            <tr>
                                <th scope="col" class="zn-table-highlight zn-table-checkbox-column">
                                    <input
                                        id="inventory-validated-all"
                                        type="checkbox"
                                        [checked]="allInventoryValidated()"
                                        (ngModelChange)="onToggleAllInventoryValidated($event)"
                                        [ngModel]="allInventoryValidated()"
                                    />
                                </th>
                                <th scope="col" class="zn-table-highlight zn-table-checkbox-column">
                                     <label for="inventory-validated-all">{{ columnHeaderKeys.inventoryValidated | abpLocalization }}</label>
                                </th>
                                <th scope="col">{{ columnHeaderKeys.inventoryType | abpLocalization }}</th>
                                <th scope="col">{{ columnHeaderKeys.inventoryYear | abpLocalization }}</th>
                                <th scope="col">{{ columnHeaderKeys.inventoryDate | abpLocalization }}</th>
                                <th scope="col">{{ columnHeaderKeys.stand | abpLocalization }}</th>
                                <th scope="col">{{ columnHeaderKeys.cycle | abpLocalization }}</th>
                                <th scope="col">{{ columnHeaderKeys.rotation | abpLocalization }}</th>
                                <th scope="col">{{ columnHeaderKeys.area | abpLocalization }}</th>
                                <th scope="col">{{ columnHeaderKeys.productivityParameters | abpLocalization }}</th>
                                <th scope="col">{{ columnHeaderKeys.dab | abpLocalization }}</th>
                                <th scope="col">{{ columnHeaderKeys.applyHerbicide | abpLocalization }}</th>
                                <th scope="col">{{ columnHeaderKeys.stumpCandidateToRegrowth | abpLocalization }}</th>
                                <th scope="col">{{ columnHeaderKeys.applyFeller | abpLocalization }}</th>
                                <th scope="col">{{ columnHeaderKeys.measurementType | abpLocalization }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            @for (row of rows(); track row.id ?? row.standCycleRotationId ?? row.standName; let rowIndex = $index) {
                            <tr>
                                <td class="zn-table-highlight zn-table-checkbox-column" colspan="2">
                                    <input
                                        [id]="'inventory-validated-' + (row.id ?? row.standCycleRotationId ?? rowIndex)"
                                        type="checkbox"
                                        [(ngModel)]="row.isInventoryValidated"
                                    />
                                </td>
                                <td>{{ row.inventoryTypeName }}</td>
                                <td>{{ row.inventoryYear }}</td>
                                <td>{{ row.inventoryDate }}</td>
                                <td>{{ row.standName }}</td>
                                <td>{{ row.cycleNumber }}</td>
                                <td>{{ row.rotationNumber }}</td>
                                <td>{{ row.standArea }}</td>
                                <td>{{ row.productivityParameterName }}</td>
                                <td>{{ row.dab }}</td>
                                <td>{{ row.stumpApplicationName }}</td>
                                <td class="zn-table-checkbox-column">
                                    <input
                                        [id]="'stump-candidate-to-regrowth-' + (row.id ?? row.standCycleRotationId ?? rowIndex)"
                                        type="checkbox"
                                        [checked]="!!row.isStumpCandidateToRegrowth"
                                        disabled
                                    />
                                </td>
                                <td class="zn-table-checkbox-column">
                                    <input
                                        [id]="'apply-feller-' + (row.id ?? row.standCycleRotationId ?? rowIndex)"
                                        type="checkbox"
                                        [checked]="!!row.applyFeller"
                                        disabled
                                    />
                                </td>
                                <td>{{ row.measurementTypeName }}</td>
                            </tr>
                            }
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>
